import { Injectable } from "@angular/core";
import { Router, UrlTree } from "@angular/router";
import { map, Observable } from "rxjs";
import { ApiService } from "../api/api.service";

@Injectable({ providedIn: "root" })
export class AuthenticatedGuard {
    constructor(
        private api: ApiService,
        private router: Router
    ) {}

    public canActivate(): Observable<boolean | UrlTree> {
        return this.api.session.isAuthenticated().pipe(
            map(isLoggedIn => {
                if (!isLoggedIn) {
                    return this.router.createUrlTree(["/"]);
                }
                return true;
            })
        );
    }
}
